var GtxMessagingCounter = (function () {


    const {events: menuCountersManagerEvents} = require('./gtx-menu-counters-worker-manager')

    const menuMessagingCounterClass = "menu-messaging-counter";

    const counterElements = document.getElementsByClassName(menuMessagingCounterClass);


    const events = {
        MENU_TOOLTIP_VISIBLE: "gtx_menu_messaging_counter_tooltip_visible",
    };


    const loadingHandler = ev  => {
        if(ev.detail?.isLoading) {
            addIsLoading()
        }else{
            removeIsLoading()
        }
    }

    const addIsLoading = () => {
        // TODO: to be removed when the new menu is released
        for (let elem of counterElements) {
            elem.classList.add("is-loading");
        }

        window.dispatchEvent(new CustomEvent(events.LOADING_MSG_COUNTER, { detail: { isLoading: true } }));
    };

    const removeIsLoading = () => {
        // TODO: to be removed when the new menu is released
        for (let elem of counterElements) {
            elem.classList.remove("is-loading");
        }

        window.dispatchEvent(new CustomEvent(events.LOADING_MSG_COUNTER, { detail: { isLoading: false } }));
    };

    const setUnreadThreadsCount = (value) => {
        if (value === null || value === undefined || !value.toString) return;

        let valueString = "";
        if (value === 0) {
            valueString = "";
        } else if (value > 99) {
            valueString = "99+";
        } else {
            valueString = value.toString();
        }
    };

    const handleCountersUpdate = ev => {
        setUnreadThreadsCount(ev.detail.unreadThreads || 0)
    }

    const initialize = () => {
        // TODO: remove after new version of menu is released
        for (let elem of counterElements) {
            elem.classList.remove("gx-is-hidden");
        }

        
        window.addEventListener(menuCountersManagerEvents.LOADING_COUNTERS, loadingHandler)
        window.addEventListener(menuCountersManagerEvents.UPDATE_COUNTERS, handleCountersUpdate)

    };

    return {
        initialize,
    };
})();

module.exports = GtxMessagingCounter;
